import { render, staticRenderFns } from "./rh-base.vue?vue&type=template&id=ef9f97d8&"
import script from "./rh-base.vue?vue&type=script&lang=ts&"
export * from "./rh-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports